import { render, staticRenderFns } from "./dormTypeDialog.vue?vue&type=template&id=c120ae06&"
import script from "./dormTypeDialog.vue?vue&type=script&lang=js&"
export * from "./dormTypeDialog.vue?vue&type=script&lang=js&"
import style0 from "./dormTypeDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports